import { cacheService } from '../services/cacheService';
import { API_BASE_URL } from '../config/api';

interface ActivityLog {
  id: string;
  type: 'ERROR' | 'WARNING' | 'INFO';
  action: string;
  details: string;
  userId: string;
  timestamp: string;
  synced: boolean;
}

export const logActivity = async (
  type: 'ERROR' | 'WARNING' | 'INFO',
  message: string,
  details?: Record<string, any>
): Promise<void> => {
  try {
    const logId = `log-${Date.now()}-${Math.random().toString(36).substr(2, 9)}`;
    const userId = localStorage.getItem('userId') || 'system';
    const timestamp = new Date().toISOString();
    const logDetails = details ? JSON.stringify(details) : '{}';

    // Store in IndexedDB
    await cacheService.set('activity_logs', {
      id: logId,
      type,
      action: message,
      details: logDetails,
      userId,
      timestamp,
      synced: false
    });

    // Log to console in development
    if (process.env.NODE_ENV === 'development') {
      console.log(`[${type}] ${message}`, details);
    }

    // Send to server if online
    if (navigator.onLine) {
      try {
        // TODO: Implement logs endpoint in Laravel API
        // await fetch(`${API_BASE_URL}/logs`, {
        //   method: 'POST',
        //   headers: {
        //     'Content-Type': 'application/json',
        //     'Authorization': `Bearer ${localStorage.getItem('token') || ''}`
        //   },
        //   body: JSON.stringify({
        //     id: logId,
        //     type,
        //     message,
        //     details: logDetails,
        //     userId,
        //     timestamp
        //   })
        // });
        console.log('Activity logged (server endpoint not implemented):', {
          id: logId,
          type,
          message,
          details: logDetails,
          userId,
          timestamp
        });
      } catch (error) {
        console.error('Failed to send log to server:', error);
      }
    }
  } catch (error) {
    console.error('Failed to log activity:', error);
  }
};